import { Card, Col, Container, Row } from 'react-bootstrap'
import { useEffect } from 'react'
import AOS from 'aos'
import './Climates.css'


const Climates = () => {
    useEffect(() => {
        AOS.init({
            duration : 1500
        })
        AOS.refresh()
    }, [])

    return (
        <main className='climates'>
            <Container>
                <Row xs={1}>
                    <Col className='my-5'>
                        <Row className='justify-content-center align-items-center'>
                            <Col sm={'12'} md={'6'}>
                                <img data-aos='fade-down' src='./img/img1.jpg' className='img-fluid' alt='Foto 1' />
                            </Col>
                            <Col sm={'12'} md={'6'}>
                                <Card className='card1' data-aos='fade-left'>
                                   <p>
                                        Nuestro departamento de Climatización ofrece una respuesta global, 
                                        tanto en Climatización industrial, como comercial, llevando consigo 
                                        toda la escala de servicios, desde el Asesoramiento, Suministro, 
                                        Instalación y Mantenimiento, sin omitir la legalización o la realización 
                                        de Proyectos, dando un servicio completo.
                                    </p>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </main>
    )
}

export default Climates